import moment from "moment";

export const calculateAge = (birthDate)=>{
  const today = moment();
  const birthMoment = moment(birthDate, "DD-MM-YYYY");

  const years = today.diff(birthMoment, 'years');
  birthMoment.add(years, 'years');

  if (years > 0) {
    return `${years} year(s)`;
  }

  const months = today.diff(birthMoment, 'months');
  birthMoment.add(months, 'months');

  if (months > 0) {
    return `${months} month(s)`;
  }

  const days = today.diff(birthMoment, 'days');
  return `${days} day(s)`;
};
